import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppStateService } from '@siza-staff-care/shared/app-state';
import { Observable } from 'rxjs';
@Injectable()
export class JwtAuthInterceptor implements HttpInterceptor {
	constructor(private appState: AppStateService) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		// add Bearer authorization header if the JWT is set.
		const jwt = this.appState.jwt;
		if (jwt) {
			const bearer = `Bearer ${jwt}`;

			// When the INI file uses Windows Authentication, the session token is sent in the X-ScSession header,
			// otherwise it is sent in the Authorization header.

			// Note also - the correct IIS configuration for Windows Authentication to work is to set Windows Authentication
			// enabled, and Anonymous Authentication disabled.
			if (this.appState.customisation?.windowsAuthentication) {
				request = request.clone({
					headers: request.headers.set('X-ScSession', bearer),
				});
			} else {
				request = request.clone({
					setHeaders: {
						Authorization: bearer,
					},
				});
			}
		}

		return next.handle(request);
	}
}
